import { defineMessages } from 'react-intl';

export default defineMessages({
    daysAgo: {
        id: 'ent.gateway.activity.date.filter.days ago',
        defaultMessage: '{days} days ago',
    },
    escalationDate: {
        id: 'ent.gateway.directives.activity-summary.Escalation Date',
        defaultMessage: 'Escalation Date',
    },
    createdBy: {
        id: 'ent.gateway.directives.activity-view-summary.Created By',
        defaultMessage: 'Created By',
    },
    aType: {
        id: 'ent.gateway.directives.activity-view-summary.Type',
        defaultMessage: 'Type',
    },
    created: {
        id: 'ent.gateway.directives.activity-view-summary.Created',
        defaultMessage: 'Created',
    },
    description: {
        id: 'ent.gateway.directives.activity-view-summary.Description',
        defaultMessage: 'Description',
    },
    completed: {
        id: 'ent.gateway.directives.activity-view-summary.COMPLETED',
        defaultMessage: 'COMPLETED',
    },
    complete: {
        id: 'ent.gateway.directives.activity-view-summary.Complete',
        defaultMessage: 'Complete',
    },
    yesterday: {
        id: 'ent.gateway.activity.date.filter.Yesterday',
        defaultMessage: 'Yesterday',
    },
    tomorrow: {
        id: 'ent.gateway.activity.date.filter.Tomorrow',
        defaultMessage: 'Tomorrow',
    },
    today: {
        id: 'ent.gateway.activity.date.filter.Today',
        defaultMessage: 'Today',
    },
    monday: {
        id: 'ent.gateway.activity.date.filter.Monday',
        defaultMessage: 'Monday',
    },
    tuesday: {
        id: 'ent.gateway.activity.date.filter.Tuesday',
        defaultMessage: 'Tuesday',
    },
    wednesday: {
        id: 'ent.gateway.activity.date.filter.Wednesday',
        defaultMessage: 'Wednesday',
    },
    thursday: {
        id: 'ent.gateway.activity.date.filter.Thursday',
        defaultMessage: 'Thursday',
    },
    friday: {
        id: 'ent.gateway.activity.date.filter.Friday',
        defaultMessage: 'Friday',
    },
    saturday: {
        id: 'ent.gateway.activity.date.filter.Saturday',
        defaultMessage: 'Saturday',
    },
    sunday: {
        id: 'ent.gateway.activity.date.filter.Sunday',
        defaultMessage: 'Sunday',
    },
    for: {
        id: 'ent.gateway.activity.date.filter.For',
        defaultMessage: 'for',
    },
    duedate: {
        id: 'ent.gateway.activity.date.filter.Due Date',
        defaultMessage: 'Due Date',
    },
    priority: {
        id: 'ent.gateway.activity.date.filter.Priority',
        defaultMessage: 'Priority',
    },
    activityDescription: {
        id: 'ent.gateway.activity.date.filter.Activity Description',
        defaultMessage: 'Activity Description',
    },
    notes: {
        id: 'ent.gateway.activity.date.filter.Notes',
        defaultMessage: 'Notes',
    }

});
